import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[positiveNumber]'
})
export class PositiveNumberDirective {

   // === equivalent to handleGlobalNumberInput ===
  @HostListener('onInput', ['$event'])
  onInput(e: any): void {
    const input = e?.event?.target as HTMLInputElement;

    if (input?.value?.includes('-')) {
      input.value = input.value.replace(/-/g, '');
    }
  }

  // === equivalent to handleGlobalNumberChange ===
  @HostListener('onValueChanged', ['$event'])
  onValueChanged(e: any): void {
    if (e?.value < 0) {
      e.component.option('value', 0);
    }
  }
}
